import React, { useEffect } from 'react';
import { useQuery } from 'react-query';

import styled from 'styled-components';

import { getHoldings } from 'apis/HoldingAPI';
import Select from 'components/lib/Select';
import { GroupType } from 'types/groups';
import { HoldingType } from 'types/holding';

import { useCommunityAdminContext } from './CommunityAdminContextProvider';

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

const Label = styled.span`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--text-primary);
  width: 102px;
  text-align: right;
`;

const CommunityAdminContentHoldingSelector = () => {
  const { community, selectedHoldings, setSelectedHoldings } = useCommunityAdminContext();

  const { data } = useQuery({
    queryKey: ['holdings'],
    queryFn: () => getHoldings(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (community) {
      const communityHoldingGroups = community?.groups.filter((group: GroupType) => Boolean(group.holding));
      const communityHoldings = communityHoldingGroups.map((group: GroupType) => group.holding);
      setSelectedHoldings(communityHoldings as HoldingType[]);
    }
  }, [community]);

  const holdingsOptions = (data || []).map((holding: HoldingType) => ({
    value: holding.id,
    label: holding.name,
  }));

  const handleSelection = (value: number) => {
    const selectedHoldings = (data || []).filter((holding: HoldingType) => value == holding.id);

    if (selectedHoldings) {
      setSelectedHoldings(selectedHoldings);
    }
  };

  return (
    <Container>
      <Label>Owner</Label>
      <Select
        showSearch
        className={'rectangular'}
        allowClear
        filterOption={(input, option) => option?.name?.toLowerCase().includes(input.toLowerCase())}
        disabled={!holdingsOptions?.length}
        style={{ width: 342, height: 36 }}
        options={holdingsOptions}
        onClear={() => setSelectedHoldings(undefined)}
        value={(selectedHoldings ?? []).map((holding: HoldingType) => holding.id)}
        onSelect={handleSelection}
        dropdownStyle={{
          padding: 0,
          borderRadius: 0,
          border: '1px solid var(--line-gray)',
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
        }}
      />
    </Container>
  );
};

export default CommunityAdminContentHoldingSelector;
